// extracted by mini-css-extract-plugin
export default {"menu":"fb","button":"gb","buttonIcon":"hb","list":"ib","buttonActive":"jb","listWrapper":"kb"};